import { render, staticRenderFns } from "./modal_status.vue?vue&type=template&id=0b9c053c&scoped=true&"
import script from "./modal_status.vue?vue&type=script&lang=js&"
export * from "./modal_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c053c",
  null
  
)

export default component.exports